import React from 'react';

import icon_header_search from '../assets/img/common/icon_header_search.svg';

export const TOPMENU = {
    "TOP": 1,
    "ARCHIVE": 2,
    "SEARCH": 3
}
type HeaderMenuProps = {
    current?:number | undefined,
}
/**
 * ヘッダーメニューを表示する
 * @param current 現在のメニュー（定数：TOPMENUで指定）
 */
const HeaderMenu:React.FC<HeaderMenuProps> = ({current = undefined}) => {
    
    return (
    <nav className="l-header__menu" aria-label="メインメニュー">
    <ul>
        <li><a href="/"  aria-current={current === TOPMENU.TOP} >ホーム</a></li>
        <li><a href="/archive/"  aria-current={current === TOPMENU.ARCHIVE} >年度別アーカイブ</a></li>
        <li><a href="/YDS/search/YDSG010"  aria-current={current === TOPMENU.SEARCH} ><span className="c-icon-text"><svg width={16} height={18}><use href={`${icon_header_search}#iconHeaderSearch`} /></svg></span>語句検索</a></li>
    </ul>
    </nav>
    );
};
export default HeaderMenu;